export const SET_MYCOURSES = 'SET_MYCOURSES';